const columns = {
    AREA: [

        {
            title: '_area_name_',
            key: 'name',
            isRequired: true,
            canChange: {
                type: 'text',
            },
            isKey: true,
            dataSort: false,
            showInTable: true
        },
        {
            title: '_area_',
            key: 'area',
            isRequired: true,
            canChange: {
                type: 'text',
            },
            isKey: false,
            dataSort: false,
            showInTable: true
        },
        {
            title: '_coordinates_',
            key: 'coordinates',
            isRequired: false,
            canChange: {
                type: 'area_coordinate',
            },
            isKey: false,
            dataSort: false,
            showInTable: false
        }
    ]
}
export default {
    getColumns() {
        return columns.AREA;
    }
}
